class MobileVideo {
  constructor() {
    let cache = {};

    let initFunc = () => {
      initCache();
      registerEvents();
    };

    let initCache = () => {
      const containers = new Set();
      document.querySelectorAll('video source[data-src]').forEach(source => {
        const container = source.closest('.slide') || source.closest('section');
        if (container) containers.add(container);
      });
      cache.containers = [...containers];
      cache.mq = window.matchMedia('(max-width: 768px)');
    };

    let registerEvents = () => {
      cache.containers.forEach(container => {
        const hasDualVideo = !!container.querySelector('video.desktop source[data-src]');

        const loadVideo = (e) => {
          const isMobile = typeof e === 'object' ? e.matches : cache.mq.matches;

          if (hasDualVideo) {
            const toLoad   = container.querySelector('video.' + (isMobile ? 'mobile' : 'desktop') + ' source[data-src]');
            const toUnload = container.querySelector('video.' + (isMobile ? 'desktop' : 'mobile') + ' source[data-src]');
            if (toLoad && !toLoad.src) {
              toLoad.src = toLoad.dataset.src;
              toLoad.parentElement.load();
            }
            if (toUnload && toUnload.src) {
              toUnload.src = '';
              toUnload.parentElement.load();
            }
          } else {
            const source = container.querySelector('video.mobile source[data-src]');
            if (isMobile && source && !source.src) {
              source.src = source.dataset.src;
              source.parentElement.load();
            } else if (!isMobile && source && source.src) {
              source.src = '';
              source.parentElement.load();
            }
          }
        };

        loadVideo();
        cache.mq.addEventListener('change', loadVideo);
      });
    };

    initFunc();
  }
}

export { MobileVideo };
